<template>
    <div></div>
</template>

<script>
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";

export default
{
    data() {
        return {
            lazyImages: [],
            lazyLoadImages: true
        }
    },

    mounted()
    {
        this.addPolyfills();
        this.findLazyImages();

        document.addEventListener('scroll', this.lazyLoad, detectPassiveEvents() ? { passive: true } : false);
        window.addEventListener('resize', this.lazyLoad);
        window.addEventListener('orientationchange', this.lazyLoad);

        //disable lazy load so scroll to is working correct
        document.addEventListener('toggle-vue-lazy-img', () => {
            this.lazyLoadImages = !this.lazyLoadImages;
        });

        document.addEventListener('update-vue-lazy-img', () => this.findLazyImages());

        $(document).on('shown.bs.modal', '.modal', () => {
            this.lazyLoad();
        });
    },

    methods: {
        findLazyImages()
        {
            //timeout 1 to push at the end of exec stack
            setTimeout(() => {
                this.lazyImages = [].slice.call(document.querySelectorAll('.vue--lazy-img'));
                this.lazyLoad();
            }, 1);
        },
        lazyLoad()
        {
            if(this.lazyLoadImages && this.lazyImages.length > 0) {
                this.lazyImages.forEach(lazyImage => {

                    let lazyLoad = true;

                    //image or video inside modal load when modal opens
                    if(lazyImage.closest('.modal') && !lazyImage.closest('.modal.fade.show')) {
                        lazyLoad = false;
                    }

                    if(lazyLoad) {

                        const bounding = lazyImage.getBoundingClientRect();

                        if(
                            bounding.top <= window.innerHeight && bounding.bottom >= 0
                            && getComputedStyle(lazyImage).display !== 'none'
                        ) {

                            lazyImage.src = lazyImage.dataset.src;
                            lazyImage.classList.remove('vue--lazy-img');

                            this.lazyImages = this.lazyImages.filter((image) => {
                                return image !== lazyImage;
                            });
                        }
                    }
                });
            }
        },
        addPolyfills()
        {
            if(!Element.prototype.matches) {
                Element.prototype.matches =
                    Element.prototype.msMatchesSelector ||
                    Element.prototype.webkitMatchesSelector;
            }

            if(!Element.prototype.closest) {
                Element.prototype.closest = (s) => {

                    let el = this;

                    do {
                        if(Element.prototype.matches.call(el, s)) return el;
                        el = el.parentElement || el.parentNode;
                    } while(el !== null && el.nodeType === 1);

                    return null;
                };
            }
        }
    }
}
</script>
